import { intrinsicClassName } from '../../utils/reactView';
import styles from './Spacer.module.css';

export const Spacer = intrinsicClassName('div', styles.spacer);
